import React, { useEffect, useRef } from "react";
import styles from "./AffiliatedPartners.module.css";
import partnerLogos from "../../assets/partners";

const AffiliatedPartners = () => {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;
    let clone = slider.innerHTML;
    slider.innerHTML += clone; // 무한 반복을 위해 콘텐츠 복제
  }, []);

  return (
    <section className={styles.partnersSection}>
      <h2 className={styles.title}>Affiliated Partners</h2>
      <div className={styles.sliderContainer}>
        <div className={styles.slider} ref={sliderRef}>
          {partnerLogos.map((partner, index) => (
            <a
              key={index}
              href={partner.link}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.partnerItem}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className={styles.partnerLogo}
              />
            </a>
          ))}
          {/* 무한 반복을 위해 동일한 리스트 복제 */}
          {partnerLogos.map((partner, index) => (
            <a
              key={`clone-${index}`}
              href={partner.link}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.partnerItem}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className={styles.partnerLogo}
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AffiliatedPartners;
